export default __webpack_public_path__ + "static/media/chat-image.be7a2d0a.jpg";